import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import {SubscriptionCancellationCause, SubscriptionStatus} from "../../../../../contracts/nexar-api/types";
import styles from "./status-label.module.scss";
import {getStatusConfig} from "../utils";

interface Props {
  status: SubscriptionStatus;
    cancellationCause: SubscriptionCancellationCause;
}

export function StatusLabel(props: Props) {
  const { t } = useTranslation();

  const { status,cancellationCause } = props;

  const statusSettings = getStatusConfig(status, cancellationCause);

  const wrapperClassNames = clsx(styles.StatusWrapper, styles[status]);

  return <span className={wrapperClassNames}>{t(statusSettings.textKey)}</span>;
}

export default StatusLabel;
